var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font16 pointer numberHeaderContainer",class:{
        darkblue: _vm.activeStep === _vm.number,
        green: _vm.activeStep > _vm.number,
        gray: _vm.activeStep < _vm.number || _vm.final,
    },staticStyle:{"line-height":"25px"}},[(_vm.final || _vm.number < _vm.activeStep)?_c('span',{staticClass:"numberHeader"},[_c('font-awesome-icon',{attrs:{"icon":"check","size":"xs"}})],1):_c('span',{staticClass:"numberHeader",class:{ darkblueBullet: _vm.activeStep === _vm.number }},[_vm._v(" "+_vm._s(_vm.numberFake)+" ")]),_c('div',{staticClass:"numberHeaderSubtitle",class:{
            darkblue: _vm.activeStep === _vm.number,
            green: _vm.activeStep > _vm.number,
            gray: _vm.activeStep < _vm.number || _vm.final,
        }},[_c('span',[_vm._v(_vm._s(_vm.title)+" "),(_vm.number < _vm.activeStep)?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v(" - "),_c('u',[_vm._v("Wijzigen")])]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }